module.exports = __webpack_public_path__ + "751c787cfdacb0040076d57b727380f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Instructors/images/padraig-o-brien.jpg
// module id = 35
// module chunks = 0 1